import { moduleProviderFactory } from 'core/providers';
import { PublicLayout } from 'core/layouts';
import { PasswordRecoveryChange, Unauthorized } from 'modules/membership/pages';

(function() {
	moduleProviderFactory.application.register({
		name: 'Baasic.Membership',
		routes: [
			{
				name: 'master.app.membership',
				pattern: '',
				component: [PublicLayout],
				children: [
					{
						name: 'master.app.membership.password-recovery-change',
						pattern: '/password-recovery-change',
						component: PasswordRecoveryChange,
					},
				],
			},
			{
				name: 'unauthorized',
				pattern: '/unauthorized',
				component: Unauthorized,
			},
		],
	});
})();
